// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const DELETE_AVATAR = "Vyma\u017e profilovou fotku";
export const TICKETS_TITLE = "tickets";
